import { useState, useEffect } from "react";
import { signInWithGoogle, signInWithEmail, signUpWithEmail, supabase } from "./services/supabase";

export default function App() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session) {
          const token = session.access_token;
          window.location.href = `https://stratforce-frontend.onrender.com?token=${token}`;
        }
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  const handleGoogle = async () => {
    setLoading(true);
    setError("");
    await signInWithGoogle();
  };

  const handleEmail = async () => {
    if (!email || !password) {
      setError("Por favor ingresa tu correo y contraseña.");
      return;
    }
    setLoading(true);
    setError("");
    const fn = isRegister ? signUpWithEmail : signInWithEmail;
    const { error: err } = await fn(email, password);
    if (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "Inter, sans-serif", color: "#fff",
      padding: "20px",
    }}>
      {/* Logo */}
      <div style={{ marginBottom: 48, textAlign: "center" }}>
        <div style={{ fontSize: 42, fontWeight: 800, letterSpacing: -1, marginBottom: 8 }}>
          Bio<span style={{ color: "#4db8a0" }}>scope</span>
        </div>
        <div style={{
          fontSize: 13, color: "rgba(255,255,255,0.6)",
          fontFamily: "JetBrains Mono, monospace",
          letterSpacing: 2, textTransform: "uppercase",
        }}>
          bioeconomic intelligence
        </div>
      </div>

      {/* Card */}
      <div style={{
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 16, padding: "40px 48px",
        maxWidth: 420, width: "100%",
        backdropFilter: "blur(10px)",
        textAlign: "center",
      }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
          {isRegister ? "Crear cuenta" : "Bienvenido"}
        </h2>
        <p style={{
          fontSize: 14, color: "rgba(255,255,255,0.6)",
          marginBottom: 28, lineHeight: 1.6,
        }}>
          Plataforma de inteligencia estratégica para empresas de la bioeconomía colombiana.
        </p>

        {/* Google */}
        <button onClick={handleGoogle} disabled={loading}
          style={{
            width: "100%", padding: "13px 24px",
            background: "#fff", color: "#1a1a1a",
            border: "none", borderRadius: 10,
            fontWeight: 700, fontSize: 14,
            cursor: loading ? "not-allowed" : "pointer",
            display: "flex", alignItems: "center",
            justifyContent: "center", gap: 10,
            marginBottom: 16,
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continuar con Google
        </button>

        {/* Divider */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.15)" }} />
          <span style={{ fontSize: 12, color: "rgba(255,255,255,0.4)" }}>o</span>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.15)" }} />
        </div>

        {/* Email/Password */}
        <input
          type="email" placeholder="Correo electrónico"
          value={email} onChange={e => setEmail(e.target.value)}
          style={{
            width: "100%", padding: "12px 14px", borderRadius: 10,
            border: "1px solid rgba(255,255,255,0.2)",
            background: "rgba(255,255,255,0.08)", color: "#fff",
            fontSize: 14, marginBottom: 10, boxSizing: "border-box",
            outline: "none",
          }}
        />
        <input
          type="password" placeholder="Contraseña"
          value={password} onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleEmail()}
          style={{
            width: "100%", padding: "12px 14px", borderRadius: 10,
            border: "1px solid rgba(255,255,255,0.2)",
            background: "rgba(255,255,255,0.08)", color: "#fff",
            fontSize: 14, marginBottom: 16, boxSizing: "border-box",
            outline: "none",
          }}
        />

        {error && (
          <div style={{
            fontSize: 12, color: "#f87171", marginBottom: 12,
            background: "rgba(248,113,113,0.1)", padding: "8px 12px",
            borderRadius: 8, textAlign: "left",
          }}>
            {error}
          </div>
        )}

        <button onClick={handleEmail} disabled={loading}
          style={{
            width: "100%", padding: "13px 24px",
            background: "#4db8a0", color: "#fff",
            border: "none", borderRadius: 10,
            fontWeight: 700, fontSize: 14,
            cursor: loading ? "not-allowed" : "pointer",
            marginBottom: 14,
          }}>
          {loading ? "Procesando..." : isRegister ? "Crear cuenta" : "Iniciar sesión"}
        </button>

        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
          {isRegister ? "¿Ya tienes cuenta?" : "¿No tienes cuenta?"}{" "}
          <span
            onClick={() => { setIsRegister(!isRegister); setError(""); }}
            style={{ color: "#4db8a0", cursor: "pointer", fontWeight: 600 }}>
            {isRegister ? "Inicia sesión" : "Regístrate"}
          </span>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        marginTop: 40, fontSize: 11,
        color: "rgba(255,255,255,0.3)",
        textAlign: "center", lineHeight: 1.8,
      }}>
        Universidad Icesi · GGGI-ANDI Hub de Bioeconomía<br/>
        Cali, Colombia · 2026
      </div>
    </div>
  );
}